import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';

import ChapterContent from './container';


export default class ChapterContentWrapper extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  render() {
    const { match } = this.props;
    const { match: { params: { versionId } } } = this.props;

    return (
      <ChapterContent key={versionId} chapterVersionId={versionId} match={match} />
    );
  }
}
